import { getSPDataWithParams, postSPDataWithoutParams } from './services'

const CARE_ORCHESTRATION_BASE = '/api/secure/cc/support/care-orchestration'

export async function getCareOrchestrationCases(filters = {}) {
  const response = await getSPDataWithParams(`${CARE_ORCHESTRATION_BASE}/cases`, filters)
  if (response?.data?.code !== 2000) {
    const message =
      response?.data?.message ||
      response?.response?.data?.message ||
      'Unable to load care orchestration cases.'
    throw new Error(message)
  }
  return response?.data?.data?.items || []
}

// POST /assign — assigns a coordinator to a case. If assignedCoordinatorId is
// empty the backend defaults to the currently-signed-in support user.
export async function assignCareOrchestrationCase(payload) {
  const response = await postSPDataWithoutParams(`${CARE_ORCHESTRATION_BASE}/assign`, payload)
  if (response?.data?.code !== 2000) {
    const message =
      response?.data?.message ||
      response?.response?.data?.message ||
      'Unable to assign care orchestration case.'
    throw new Error(message)
  }
  return response?.data?.data?.result || null
}
